import { Link } from "react-router-dom";
import {works} from '../workconfig';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import React, { useEffect, useRef } from 'react';

// Smoke Background Component
const SmokeBackground = () => {
  const canvasRef = useRef(null);
  const animationRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;

    const ctx = canvas.getContext('2d');
    const particles = [];
    
    // Set canvas size
    const resizeCanvas = () => {
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
    };
    
    resizeCanvas();
    window.addEventListener('resize', resizeCanvas);

    // Smoke particle class
    class SmokeParticle {
      constructor() {
        this.reset();
      }
      
      reset() {
        this.x = Math.random() * canvas.width;
        this.y = canvas.height + 50;
        this.vx = (Math.random() - 0.5) * 2;
        this.vy = -Math.random() * 2 - 1;
        this.life = 1.0;
        this.decay = Math.random() * 0.01 + 0.005;
        this.size = Math.random() * 30 + 20;
        this.growth = Math.random() * 0.5 + 0.2;
      }
      
      update() {
        this.x += this.vx;
        this.y += this.vy;
        this.life -= this.decay;
        this.size += this.growth;
        this.vx *= 0.99;
        this.vy *= 0.99;
        
        if (this.life <= 0) {
          this.reset();
        }
      }
      
      draw() {
        const alpha = this.life * 0.3;
        const gradient = ctx.createRadialGradient(
          this.x, this.y, 0,
          this.x, this.y, this.size
        );
        
        gradient.addColorStop(0, `rgba(200, 200, 200, ${alpha})`);
        gradient.addColorStop(0.5, `rgba(150, 150, 150, ${alpha * 0.5})`);
        gradient.addColorStop(1, `rgba(100, 100, 100, 0)`);
        
        ctx.fillStyle = gradient;
        ctx.beginPath();
        ctx.arc(this.x, this.y, this.size, 0, Math.PI * 2);
        ctx.fill();
      }
    }

    // Create particles
    for (let i = 0; i < 15; i++) {
      particles.push(new SmokeParticle());
    }

    // Animation loop
    const animate = () => {
      // Clear with dark background
      ctx.fillStyle = 'rgba(20, 20, 20, 0.1)';
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      
      // Update and draw particles
      particles.forEach(particle => {
        particle.update();
        particle.draw();
      });
      
      animationRef.current = requestAnimationFrame(animate);
    };

    animate();

    return () => {
      window.removeEventListener('resize', resizeCanvas);
      if (animationRef.current) {
        cancelAnimationFrame(animationRef.current);
      }
    };
  }, []);

  return (
    <canvas
      ref={canvasRef}
      style={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        zIndex: 1,
        pointerEvents: 'none',
        backgroundColor: '#1a1a1a'
      }}
    />
  );
};

export default function Home() {
  const _works = [];

  works.forEach((data, i) => {
    const workassets = data.Assets;
    const workbgurl = "img/home/"+workassets+".jpg";

    const imageCol = (
      <Col lg s xs='12'>
        <div className='home-work-bg'>
          <img src={workbgurl} onClick={() => window.location.href = `/${data.Assets}`} />
        </div>
      </Col>
    );

    const textCol = (
      <Col lg s xs='12' className='home-work-text text-start px-5 d-flex flex-column justify-content-center'>
        <div className='home-work-title py-2'>
          {data.Title.split("|")[1]}
        </div>
        <div className="py-4 my-4">
          {data.Summary.map((point, idx) => (
            <div key={idx} className="py-1 my-1">
              <div dangerouslySetInnerHTML={{ __html: point.line1 }} />
              <div dangerouslySetInnerHTML={{ __html: point.line2 }} />
            </div>
          ))}
        </div>  
        <div>
          {data.Hashtag}
        </div>   
        <div>
          {data.Title.split("|")[2]}
        </div>                      
      </Col>
    );

      const textCol2 = (
      <Col lg s xs='12' className='home-work-text text-end px-5 d-flex flex-column justify-content-center'>
        <div className='home-work-title py-2'>
          {data.Title.split("|")[1]}
        </div>
        <div className="py-4 my-4">
          {data.Summary.map((point, idx) => (
            <div key={idx} className="py-1 my-1">
              <div dangerouslySetInnerHTML={{ __html: point.line1 }} />
              <div dangerouslySetInnerHTML={{ __html: point.line2 }} />
            </div>
          ))}
        </div>  
        <div>
          {data.Hashtag}
        </div>   
        <div>
          {data.Title.split("|")[2]}
        </div>                      
      </Col>
    );

    _works.push(
      <>
        <Container className='py-5 my-5 home-desktop' key={i}>
          <Row>
            {i % 2 === 0 ? [imageCol, textCol] : [textCol2, imageCol]}
          </Row>
        </Container>
        <Container className='py-5 my-5 home-mobile' key={i}>
          <Row>
            {[imageCol, textCol]}
          </Row>
        </Container>
      </>
    )
  })
  

  return (
    <>
      <div className='home'>
          <Container fluid className='home-cover' style={{ position: 'relative', overflow: 'hidden' }}>
            {/* Smoke Background */}
            <SmokeBackground />
            
            {/* Your existing content with higher z-index */}
            <Container style={{ position: 'relative', zIndex: 2 }}>
              <Row className='align-items-center'>
                <Col className='text-start'>
                    <div className='title'>
                      Hi, I'm Amber, <span className='subtitle'>a user-centered, data-driven </span>
                    </div>
                    <div className='title2 text-center'>
                      Product Designer
                    </div>
                    <div className='subtitle text-end'>
                      crafting large-scale sites and GovTech apps.
                    </div>
                    <div className='scroll_down'>
                      <button onClick={()=>window.scrollTo(0, window.innerHeight-30)}><img src='/img/scroll_down.png' alt='' /></button>
                    </div>
                </Col>
              </Row>
            </Container>
          </Container>
        <div className='home-works my-5 py-5'>
          {_works}
        </div>
      </div>
    </>
  );
}